export const BALL_COUNT = {
  _1: 1,
  _3: 3,
  _5: 5,
  _10: 10,
  _15: 15,
};

export const plinkoRowType = {
  _8: 0,
  _9: 1,
  _10: 2,
  _11: 3,
  _12: 4,
  _13: 5,
  _14: 6,
  _15: 7,
  _16: 8,
};

export const linesCountByRowType = {
  0: 8,
  1: 9,
  2: 10,
  3: 11,
  4: 12,
  5: 13,
  6: 14,
  7: 15,
  8: 16,
};

export const RiskType = {
  low: 0,
  medium: 1,
  high: 2,
};

export const RiskNameByType = {
  0: 'LOW',
  1: 'MEDIUM',
  2: 'HIGH',
};
